<header>
  <div class="logo-container d-none d-md-flex">
    <div>
      @if (logoHref) {
        <a [href]="logoHref" target="_blank">
          <img class="partner-logo" [src]="logoUrl" [alt]="partnerName + 'Logo'">
        </a>
      }
      @if (!logoHref && !!logoUrl) {
        <img class="partner-logo" [src]="logoUrl" [attr.alt]="partnerName + 'Logo'">
      }
    </div>
    <div class="logo-container__allianz">
      <div class="logo-container">
        <small>Powered by</small>
        <a [routerLink]="[partnerName, 'home']">
          <img class="logo" alt="Powered by Allianz" [src]="agaLogoUrl">
        </a>
      </div>
      @if (showPhone) {
        <app-telephone [phoneNumber]="phoneNumber"></app-telephone>
      }
    </div>
  </div>
</header>
